import React from "react";
import styles from "./AITag.module.css";
import { icon, IconComponent } from "../../../../common/components";
import { translate } from "../../../../common/providers";

const AITag = () => (
	<div className={styles.aiIndicator}>
		<IconComponent color="var(--color-dark-grey-2)" icon={icon.faWandMagicSparkles} size="2xs" />
		{translate("common:ai")}
	</div>
);

export default AITag;
